import * as React from 'react';
import { GridColumnMenuFilterUIProps } from '@progress/kendo-react-grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { GetString } from './StringResourceManager';
import { FilterDescriptor, State } from '@progress/kendo-data-query';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import {
  MultiSelect,
  ListItemProps,
  MultiSelectChangeEvent,
  TagData,
} from '@progress/kendo-react-dropdowns';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spaceBetween: {
      marginInline: 3,
    },
  })
);

export const CustomFilter = (
  props: GridColumnMenuFilterUIProps & { dataState: State }
) => {
  const classes = useStyles();

  const itemSelected = GetString('ITEMS_SELECTED');

  const selectedValue: string[] = [];

  const [value, setValue] = React.useState<string[]>(selectedValue);

  const nodeTypes: string[] = useSelector(
    (state: ApplicationState) => state.assetsReducer.nodeTypes
  );

  React.useEffect(() => {
    props.dataState.filter?.filters.map(x => {
      const props = new Map<string, FilterDescriptor[]>(Object.entries(x));
      const filters: FilterDescriptor[] = props.get('filters') || [];
      filters.map(a => {
        if (
          (Array.isArray(a.value) && a.field === 'NodeType') ||
          a.field === 'NodeInfo.NodeType'
        ) {
          a.value.map((value: string) => selectedValue.push(value));
        }
      });
    });
  }, [selectedValue]);

  const { firstFilterProps } = props;

  const itemRender = (
    li: React.ReactElement<HTMLLIElement>,
    itemProps: ListItemProps
  ) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(event: any) => itemProps.onClick(itemProps.index, event)}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  const onChange = (event: MultiSelectChangeEvent) => {
    setValue(event.target.value);
    firstFilterProps.onChange({
      value: event.target.value.length > 0 ? event.target.value : '',
      operator: event.target.value.length > 0 ? 'eq' : '',
      syntheticEvent: event.syntheticEvent,
    });
  };

  const [tags, setTags] = React.useState<TagData[] | undefined>();

  React.useEffect(() => {
    if (value.length > 0) {
      setTags([{ text: `${value.length} ${itemSelected}`, data: [...value] }]);
    } else setTags([]);
  }, [value]);

  return (
    <div className="k-filtercell">
      <MultiSelect
        data={nodeTypes}
        itemRender={itemRender}
        autoClose={true}
        value={value}
        onChange={onChange}
        tags={tags}
      />
    </div>
  );
};
